<script>
	let {
		title = null,
		backgroundColor = null,
		class: className = '',
		titleSlot = null,
		inner = null,
		children = null,
	} = $props();
</script>

<div
	class:!bg-indow-white={backgroundColor == 'white'}
	class:!bg-indow-blue={backgroundColor == 'blue'}
	class:!bg-indow-grey-light={backgroundColor == 'grey-light'}
	class:!bg-indow-grey={backgroundColor == 'grey'}
	class:!bg-indow-grey-dark={backgroundColor == 'grey-dark'}
	class:!bg-transparent={backgroundColor == 'transparent'}
	class:shadow-md={backgroundColor != 'transparent'}
	class={[
		'bubble mx-auto mb-4 grid w-full max-w-xl items-center justify-items-center justify-self-center rounded-lg px-8 py-7',
		className ?? '',
	].join(' ')}
>
	{#if title || titleSlot}
		{#if titleSlot}{@render titleSlot()}{:else}
			<h3 class="text-left">
				{title}
			</h3>
		{/if}
	{/if}

	{#if inner}{@render inner()}{:else}
		{@render children?.()}
	{/if}
</div>
